interface PersonName {
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export const getDisplayName = (person: PersonName | null | undefined): string =>
  person?.fullName ??
  [person?.firstName, person?.lastName].filter(Boolean).join(' ');
